import { decrypte, encrypte } from "../crypto";

class StorageHandler {

    constructor() {

    }

    setEncryptedValue(itemName, value = '') {
        localStorage.setItem(itemName, encrypte(value));
    }

    getEncryptedValue(itemName) {
        return decrypte(localStorage.getItem(itemName));
    }
}

export default new StorageHandler();